import React, { useState } from "react";
import { connect } from "react-redux";

import { ChevronUpIcon } from "@heroicons/react/20/solid";
import Vimeo from "@u-wave/react-vimeo";

function HowToPlay({}) {
	const [videoVisibility, setVideoVisibility] = useState(true);

	return (
		<React.Fragment>
			<link href="https://fonts.googleapis.com/css2?family=Mountains+of+Christmas:wght@700&display=swap" rel="stylesheet"/>
			<div className="pt-6 sm:pt-2">
				<div
					className="w-full text-3xl text-center font-extrabold tracking-tight text-gray-900 sm:text-4xl col-span-10"
					onClick={() => {
						setVideoVisibility(!videoVisibility);
					}}
				>
					<h2 className="font-advent text-4xl" >How To Play</h2>
					<ChevronUpIcon
						className="mx-auto w-8"
						style={{ transform: videoVisibility ? "rotate(0deg)" : "rotate(180deg)" }}
					/>
				</div>
			</div>

			{videoVisibility && (
				<div className="grid grid-cols-10 gap-6 mx-6">
					<div className="col-span-10 lg:col-span-7">
						<figure className="bg-black relative">
							<Vimeo
								video={890227743}
								responsive={true}
								showTitle={false}
								showByline={false}
								showPortrait={false}
								autoplay={false}
								onTimeUpdate={(e) => {
									//if(e.seconds > secondsWatched && e.seconds-secondsWatched <= 0.350) // If new duration is larger by < 350ms, update seconds watched
									//setSecondsWatched(e.seconds);
									//else if(e.seconds > secondsWatched && e.seconds-secondsWatched > 0.350) // If new duration is larger by > 350ms, Display warning
									//console.log("Uh oh! Seems like you skipped through the video. Progress will not be counted.");
									//if(secondsWatched/e.duration >= 0.975) // Check if last valid percentage is over 97.5% & set completed true
									//setCompleted(true);
								}}
							/>
						</figure>
					</div>

					<div className="col-span-10 lg:col-span-3 bg-white text-gray-600">
						<div className="z-10 sticky m-4 font-serif">
							<p className='mb-2'>Giving to the foodbank this year is <strong>easy</strong>. Even if there is no money to spare, we’ve got you covered. All it will take is a bit of patience this advent and we will do a donation <strong>in your name.</strong></p>

							<p className='mb-2'>Just follow these X simple steps.</p>

							<ol className={"list-decimal ml-5 mb-2"}>
								<li><strong>Click</strong> on one of the Advent Calendar Gift Boxes</li>
								<li><strong>Watch</strong> a Video and/or Answer a simple question</li>
								<li><strong>Open</strong> the gift you’re helping donate to the Foodbank</li>
								<li><strong>Sign in</strong>; so we book the gift in your name.</li>
								<li><strong>Share</strong> the gift on social media to double your impact</li>
							</ol>
							<p>What are you waiting for, start giving now.</p>
						</div>
					</div>
				</div>
			)}
		</React.Fragment>
	);
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect()(HowToPlay);
